import React from "react";
import { useSelector } from "react-redux";
import { getFeedbackForm, getProfileForm } from "../../../../redux/reducer/incbotFeedbackReducer";
import { resolveFeedbackStatusLabel, resolveRatingScalePalette } from "../../../../utils/helper";

export const RatingSystem = () => {
  const profileForm = useSelector(getProfileForm);
  const feedbackForm = useSelector(getFeedbackForm);
  const low = profileForm?.ratingSystem?.low ? profileForm?.ratingSystem?.low * 10 : 50;
  const medium = profileForm?.ratingSystem?.medium ? profileForm?.ratingSystem?.medium * 10 : 70;
  const feedbackStatus = profileForm?.feedbackStatus;
  const notRecommendedLabel = resolveFeedbackStatusLabel("Not Recommended", feedbackStatus);
  const cautiouslyRecommendedLabel = resolveFeedbackStatusLabel(
    "Cautiously Recommended",
    feedbackStatus
  );
  const recommendedLabel = resolveFeedbackStatusLabel("Recommended", feedbackStatus);
  // Empty unless the employer recoloured a verdict; the Tailwind gradient/dots below stay as-is
  // whenever every verdict is still on its default swatch.
  const { barStyle, dotStyles } = resolveRatingScalePalette(feedbackStatus);
  return (
    <div className="p-3 md:p-6">
      {/* Header */}
      <div className="md:hidden print:flex w-100 p-1 print:p-2 rounded-md border-b-4 border-teal-500 bg-teal-50 text-teal-500 text-md print:text-xl flex justify-center font-semibold mb-3 md:mb-6">
        Rating System
      </div>

      {/* Rating Scale Container */}
      <div className="bg-white rounded-lg p-3 md:p-6">
        {/* Category Labels */}
        <div className="w-full h-10 relative">
          <div className="text-center absolute left-[16.6667%] -translate-x-1/2 mx-2">
            <div className="text-xs max-sm:text-[8px] md:text-sm font-medium text-gray-700">
              {notRecommendedLabel}
            </div>
            <div
              className="w-2 h-2 bg-red-500 rounded-full mx-auto"
              style={dotStyles["Not Recommended"]}
            ></div>
          </div>
          <div className="text-center absolute left-1/2 -translate-x-1/2 mx-2">
            <div className="text-xs max-sm:text-[8px] md:text-sm font-medium text-gray-700">
              {cautiouslyRecommendedLabel}
            </div>
            <div
              className="w-2 h-2 bg-yellow-500 rounded-full mx-auto "
              style={dotStyles["Cautiously Recommended"]}
            ></div>
          </div>
          <div className="text-center absolute left-[83.3334%] -translate-x-1/2 mx-2">
            <div className="text-xs max-sm:text-[8px] md:text-sm font-medium text-gray-700">
              {recommendedLabel}
            </div>
            <div
              className="w-2 h-2 bg-green-500 rounded-full mx-auto"
              style={dotStyles["Recommended"]}
            ></div>
          </div>
        </div>

        {/* Gradient Bar */}
        <div className="relative mb-6">
          <div
            className="w-full h-2 md:h-4 bg-gradient-to-r from-red-500 via-orange-400 via-yellow-400 via-yellow-300 via-green-300 to-green-500 rounded-full"
            style={barStyle}
          ></div>

          {/* Vertical Markers */}
          <div className="absolute top-0 h-2 md:h-4 left-1/3 -translate-x-1/2">
            <div className="w-0.5 h-full bg-gray-600"></div>
          </div>
          <div className="absolute top-0 h-2 md:h-4 left-2/3 -translate-x-1/2">
            <div className="w-0.5 h-full bg-gray-600"></div>
          </div>

          {/* Percentage Markers */}
          <div className="relative -bottom-2 w-full text-xs text-gray-600">
            <span>0%</span>
            <span className="absolute left-1/3 -translate-x-1/2">{low}%</span>
            <span className="absolute left-2/3 -translate-x-1/2">{medium}%</span>
            <span className="absolute right-0">100%</span>
          </div>
        </div>

        <div className="flex flex-wrap justify-evenly mt-10 gap-1 md:gap-2 text-xs text-center">
          <div className="font-medium text-gray-700 mb-1">Very Poor &lt;= 2</div>
          <div className="font-medium text-gray-700 mb-1">Poor 3 to 4</div>
          <div className="font-medium text-gray-700 mb-1">Average = 5</div>
          <div className="font-medium text-gray-700 mb-1">Above Average = 6</div>
          <div className="font-medium text-gray-700 mb-1">Good = 7</div>
          <div className="font-medium text-gray-700 mb-1">Very Good = 8</div>
          <div className="font-medium text-gray-700 mb-1">Excellent &gt;= 9</div>
        </div>
      </div>
    </div>
  );
};
